import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, ModalDismissReasons, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../shared/services/auth/auth.service';
import { NotificacionesService } from 'src/app/shared/services/notificacion/notificacion.service';
import { ErrorService } from 'src/app/shared/services/error/error.service';
import { Subscription, Subject } from 'rxjs';
import { ComprobantesViewComponent } from 'src/app/components/comprobantes/components/comprobantes-view/comprobantes-view.component';
import { OrdenesEntregaViewComponent } from 'src/app/components/ordenes_entrega/ordenes-entrega-view/ordenes-entrega-view.component';
import { CANAL_SOCKET, TIPO_RECEPTOR_CLIENTE } from 'src/app/shared/utils/constantes/constantes-notificaciones';

@Component({
  selector: 'app-notificaciones-modal',
  templateUrl: './notificaciones-modal.component.html',
  styleUrls: ['./notificaciones-modal.component.scss']
})
export class NotificacionesModalComponent implements OnInit, OnDestroy {

  public filterNotif: FormGroup;
  page: number;
  previousPage: number;
  pageSize: number = 6;
  totalElements: number;
  private subscriptions: Subscription[] = [];
  public Notificaciones: any;

  constructor(
    public activeModal: NgbActiveModal, 
    private fb: FormBuilder, 
    private authService: AuthService,
    private notificacionesService: NotificacionesService, 
    private errorService: ErrorService, 
    private modalService: NgbModal
  ) {
    this.filterNotif = this.fb.group({
      estado: ['N'],
    });
    this.subscriptions.push(
      this.filterNotif.controls.estado.valueChanges.subscribe(() => this.loadNotif(this.cargarFiltros(0)))
    );
  }

  ngOnInit(): void {
    this.page = 0;
    this.previousPage = 1;

    // this.loadNotif(this.cargarFiltros(this.page));
    this.subscriptions.push(
      this.notificacionesService.refreshListado.subscribe((refresh) => {
        if (refresh) {
          this.loadNotif(this.cargarFiltros(this.page));
        }
      })
    );
  }

  cargarFiltros(page) {
    // MC CATFER-117 Se cambian los parámetros para adaptarlo al nuevo esquema
    let datos: any = {
      IdsReceptoresConTipos: `[${this.authService.usuario.id_cliente}|${TIPO_RECEPTOR_CLIENTE}]`,
      IdsNotifCanales: CANAL_SOCKET,
      PageNumber: page+1,
      PageSize: 6,
      Orden: 7,
      SentidoOrden: 'desc',
    };
    let estado = this.filterNotif.get('estado').value;
    datos.Estados = estado !== 'T' ? estado : 'N,L';

    return datos;
  }

  loadNotif(datos: object) {
    const susc = this.notificacionesService.getNotificaciones(datos).subscribe((data) => {
      this.Notificaciones = data.Data;
      this.totalElements = data.TotalRecords;
    },
      (error: any) => {
        this.errorService.getError(error.status);
      });
    this.subscriptions.push(susc);
  }

  ngOnDestroy() {
    this.notificacionesService.refreshListado.next(false);
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  ObservacionToJSON(observacion: string): any {
    return JSON.parse(observacion);
  }

  setPage(pageInfo) {
    const page = pageInfo.first / pageInfo.rows;
    this.page = page;
    this.loadNotif(this.cargarFiltros(this.page));
  }

  marcarTodoLeidos() {
    // MC CATFER-117 Se cambian los parámetros para adaptarlo al nuevo esquema
    const datos: any = { 
      IdsReceptoresConTipos: `[${this.authService.usuario.id_cliente}|${TIPO_RECEPTOR_CLIENTE}]`,
      IdsNotifCanales: CANAL_SOCKET,
      Estados: 'N',
      PageSize: 1000,
    }
    const susc = this.notificacionesService.getNotificaciones(datos).subscribe((data) => {
      let notificaciones: any = data.Data;
      notificaciones.forEach(notif => {
        this.marcarLeidos(notif.Id, false);
      });
      this.page = 0;
      this.previousPage = 1;
    },
      (error: any) => {
        this.errorService.getError(error.status);
      });
    this.subscriptions.push(susc);
  }

  marcarLeidos(idNotif: number, reload: boolean) {
    let notifPatch: any = [
      {
        "op": "replace",
        "path": "/Estado",
        "value": "L"
      }
    ];
    const susc = this.notificacionesService.pathNotificaciones(idNotif, notifPatch).subscribe((data) => {
      if (reload) {
        this.page = 0;
        this.previousPage = 1;
        this.notificacionesService.refreshListado.next(true);
      }
    },
      (error: any) => {
      });
      this.subscriptions.push(susc);
  }

  LeerNotif(notif: any) {
    let dominio : string = notif.Observacion.dominio_registro;
    let estado: string = notif.Estado;
    let tipoCba: string = '';
    switch (dominio) {
      case 'OE':
        this.getOrdenEntrega(notif.IdRegistro);
        tipoCba = 'Ordenes';
        break;

      default:
        break;
    }
    if (estado === 'N') {
      this.marcarLeidos(notif.Id, true)
    }
  }

  getComprobante(IdRegistro: number, tipoCba: string) {
    const modalRef = this.modalService.open(ComprobantesViewComponent, { size: <any>'xl' });
    modalRef.componentInstance.comprobanteId = IdRegistro;
    modalRef.componentInstance.tipoComprobante = tipoCba;
    modalRef.result.then((resolve) => {
    });
  }

  getOrdenEntrega(id: number) {
    const modalRef = this.modalService.open(OrdenesEntregaViewComponent, { size: 'lg' });
    modalRef.componentInstance.ordenId = id;
    modalRef.result.then((resolve) => {
    });
  }

}
